module.exports = __webpack_public_path__ + "img/banner01.12a0649a.png";